import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AskCustomerRotateModule } from './ask-customer-rotate/ask-customer-rotate.module';
import { BalanceComponent } from './balance/balance.component';
import { BonusSelectorComponent } from './bonus-selector/bonus-selector.component';
import { BoydRewardsCardComponent } from './boyd-rewards-card/boyd-rewards-card.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ContactSupportComponent } from './contact-support/contact-support.component';
import { CustomNavbarComponent } from './custom-navbar/custom-navbar.component';
import { DateDefaultFormatPipe } from '../pipes/date-format.pipe';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { DateTimestampFormatPipe } from '../pipes/date-timestamp-format.pipe';
import { DatetTimeOnlyFormatPipe } from '../pipes/date-format-timeonly.pipe';
import { DepositAllMethodsComponent } from './cashier/deposit-all-methods/deposit-all-methods.component';
import { DepositBonusOffersComponent } from './cashier/deposit-bonus-offers/deposit-bonus-offers.component';
import { DepositButtonComponent } from './cashier/deposit-button/deposit-button.component';
import { DepositDefaultAmountsComponent } from './cashier/deposit-default-amounts/deposit-default-amounts.component';
import { DepositLimitComponent } from './cashier/deposit-limit/deposit-limit.component';
import { DepositLogoComponent } from './cashier/deposit-logo/deposit-logo.component';
import { DeviceDetailsCollectorService } from '../services/kount/kount.service';
import { directivesModule } from '../directives/directives.module';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { GamblingProblemComponent } from './gambling-problem/gambling-problem.component';
import { GameModule } from './game/game.module';
import { GamesBonusFreeSpinsComponent } from './games-bonus-free-spins/games-bonus-free-spins.component';
import { InactivityComponent } from './../../app/pages/inactivity/inactivity.component';
import { LastPlayedGamesModule } from './last-played-games/last-played-games.module';
import { LimitsTableRowComponent } from './limits-table-row/limits-table-row.component';
import { MyRewardsComponent } from './my-rewards/my-rewards.component';
import { NavigationTabsComponent } from './navigation-tabs/navigation-tabs.component';
import { NoteBoxComponent } from './note-box/note-box.component';
import { OnlineTimeComponent } from './online-time/online-time.component';
import { PipesModule } from '../pipes/pipes.module';
import { ProgressingComponent } from './progressing/progressing.component';
import { RedeemButtonComponent } from './redeem-button/redeem-button.component';
import { RedirectComponent } from './redirect/redirect.component';
import { RewardsCardComponent } from './rewards-card/rewards-card.component';
import { RewardsCurrentStatusComponent } from './rewards-components/rewards-current-status/rewards-current-status.component';
import { RewardSliderComponent } from './rewards-components/reward-slider/reward-slider.component';
import { RewardsRequestConfirmComponent } from './rewards-components/rewards-request-confirm/rewards-request-confirm.component';
import { RewardsSuccessFailMessageComponent } from './rewards-components/rewards-success-fail-message/rewards-success-fail-message.component';
import { RewardsTabComponent } from './rewards-components/rewards-tab/rewards-tab.component';
import { RglogoComponent } from './rglogo/rglogo.component';
import { SecondaryTitleComponent } from './secondary-title/secondary-title.component';
import { ServerNotificationComponent } from './../../app/pages/server-notification/server-notification.component';
import { SidemenuComponent } from './sidemenu/sidemenu';
import { SuccessMessageComponent } from './success-message/success-message.component';
import { TransactionListComponent } from './transaction-list/transaction-list.component';
import { ValidatePinComponent } from './validate-pin/validate-pin.component';
import { WebcontentComponent } from './webcontent/webcontent.component';
import { GeoLocationViewComponent } from './geo-location-view/geo-location-view.component';
import { MobileCarousel } from './mobile-carousel/mobile-carousel.component';

@NgModule({
  declarations: [
    BalanceComponent,
    BonusSelectorComponent,
    BoydRewardsCardComponent,
    CalendarComponent,
    ContactSupportComponent,
    CustomNavbarComponent,
    DateTimePickerComponent,
    DepositAllMethodsComponent,
    DepositBonusOffersComponent,
    DepositButtonComponent,
    DepositDefaultAmountsComponent,
    DepositLimitComponent,
    DepositLogoComponent,
    ErrorMessageComponent,
    GamblingProblemComponent,
    GamesBonusFreeSpinsComponent,
    InactivityComponent,
    LimitsTableRowComponent,
    MyRewardsComponent,
    NavigationTabsComponent,
    NoteBoxComponent,
    OnlineTimeComponent,
    ProgressingComponent,
    RedeemButtonComponent,
    RedirectComponent,
    RewardsCardComponent,
    RewardsCurrentStatusComponent,
    RewardSliderComponent,
    RewardsRequestConfirmComponent,
    RewardsSuccessFailMessageComponent,
    RewardsTabComponent,
    SecondaryTitleComponent,
    ServerNotificationComponent,
    SidemenuComponent,
    SuccessMessageComponent,
    TransactionListComponent,
    GeoLocationViewComponent,
    ValidatePinComponent,
    WebcontentComponent,
    MobileCarousel
  ],
  imports: [
    AskCustomerRotateModule,
    CommonModule,
    DateDefaultFormatPipe,
    DateTimestampFormatPipe,
    DatetTimeOnlyFormatPipe,
    directivesModule,
    FormsModule,
    GameModule,
    IonicModule,
    LastPlayedGamesModule,
    NgxPaginationModule,
    PipesModule,
    ReactiveFormsModule,
    RglogoComponent,
  ],
  exports: [
    BalanceComponent,
    BonusSelectorComponent,
    BoydRewardsCardComponent,
    CalendarComponent,
    ContactSupportComponent,
    CustomNavbarComponent,
    DateTimePickerComponent,
    DepositAllMethodsComponent,
    DepositBonusOffersComponent,
    DepositButtonComponent,
    DepositDefaultAmountsComponent,
    DepositLimitComponent,
    DepositLogoComponent,
    ErrorMessageComponent,
    GamblingProblemComponent,
    GamesBonusFreeSpinsComponent,
    InactivityComponent,
    LimitsTableRowComponent,
    MyRewardsComponent,
    NavigationTabsComponent,
    NoteBoxComponent,
    OnlineTimeComponent,
    PipesModule,
    ProgressingComponent,
    RedeemButtonComponent,
    RedirectComponent,
    RewardsCardComponent,
    RewardsCurrentStatusComponent,
    RewardSliderComponent,
    RewardsRequestConfirmComponent,
    RewardsSuccessFailMessageComponent,
    RewardsTabComponent,
    RglogoComponent,
    SecondaryTitleComponent,
    ServerNotificationComponent,
    SidemenuComponent,
    SuccessMessageComponent,
    GeoLocationViewComponent,
    TransactionListComponent,
    ValidatePinComponent,
    WebcontentComponent,
    MobileCarousel
  ],
  providers: [
    DeviceDetailsCollectorService
  ]
})

export class ComponentsModule { }
